import { useEffect } from 'react'
import { motion } from 'framer-motion'
import imgSeguimiento from '../../Imgs/terms.svg'

const sections = [
  {
    title: 'Localizaciones y ofertas en tiempo real',
    content:
      'Un mercado en línea en tiempo real que conecta a restaurantes y locales que ofrecen ofertas por cupones de descuentos para ser canjeados en este momento.\n\nLas ofertas que se encuentran en Pide y Pasa son todas ofertas por tiempo limitado que suceden en ese momento, o "en vivo" en la plataforma. Encuentre ofertas exclusivas y canjéelas en su restaurante local favorito al instante. Te ayudamos a ahorrar hoy y todos los días.'
  },
  {
    title: 'Uso del servicio',
    content:
      'Al utilizar Pide y Pasa, aceptas cumplir con estos términos y condiciones. El servicio está destinado únicamente para uso personal y no comercial. Queda prohibido el uso del servicio para actividades ilegales o no autorizadas.'
  },
  {
    title: 'Privacidad y datos personales',
    content:
      'Recopilamos y procesamos tus datos personales de acuerdo con nuestra política de privacidad. Al usar el servicio, consientes el tratamiento de tus datos para mejorar la experiencia de usuario y ofrecerte ofertas personalizadas.'
  },
  {
    title: 'Responsabilidad',
    content:
      'Pide y Pasa actúa como intermediario entre los usuarios y los establecimientos. No somos responsables de la calidad de los productos ofrecidos por los restaurantes ni de los tiempos de preparación. Cada establecimiento es responsable de sus propias ofertas y condiciones.'
  },
  {
    title: 'Modificaciones',
    content:
      'Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación. El uso continuado del servicio implica la aceptación de los nuevos términos.'
  }
]

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="flex justify-center">
      <div className="container">
        <div className="m-[50px]">
          <h1 className="text-center text-3xl font-extrabold text-gray-900 md:text-5xl">
            Términos y condiciones
          </h1>
        </div>

        {/* Primera sección con imagen */}
        <motion.div
          initial={{ x: -400 }}
          animate={{ x: 0 }}
          transition={{ duration: 1.2 }}
          className="mb-[70px] mt-[70px] flex flex-col items-center justify-center border-t-2 md:flex-row md:justify-evenly"
        >
          <div className="flex w-[90%] flex-col gap-7 pt-10 md:w-[40%]">
            <h2 className="text-center text-xl font-bold text-Main md:text-left md:text-2xl">
              {sections[0].title}
            </h2>
            <p className="text-justify text-sm leading-relaxed text-gray-700 md:text-base">
              {sections[0].content.split('\n\n').map((p, i) => (
                <span key={i}>
                  {p}
                  {i === 0 && (
                    <>
                      <br />
                      <br />
                    </>
                  )}
                </span>
              ))}
            </p>
          </div>
          <img
            src={imgSeguimiento}
            alt="Aplicación de seguimiento"
            className="mt-8 h-auto max-w-[300px] rounded-3xl md:mt-0 md:max-w-[400px]"
          />
        </motion.div>

        {/* Resto de secciones */}
        <div className="mb-16 px-6 md:px-12">
          {sections.slice(1).map((section, index) => (
            <motion.div
              key={section.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="mb-10 border-b pb-8 last:border-b-0"
            >
              <h2 className="mb-4 text-xl font-bold text-Main md:text-2xl">
                {section.title}
              </h2>
              <p className="text-justify text-sm leading-relaxed text-gray-700 md:text-base">
                {section.content}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditions
